import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Text } from "../../../themes/userq/Text/Text";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../themes/userq/Button/Button";
import { CircularNameIcon } from "../../../themes/userq/CircularNameIcon/CircularNameIcon";
import { getWorkspaceService } from "../../../../services/workspaces";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { showToast } from "../../../../lib/helpers";
import { MembersDropdownList } from "../../../themes/userq/MembersDropdownList/MembersDropdownList";
import { updateProjectService } from "../../../../services/workspaceprojects";
import "./create-new-project-modal.css";

export default function ProjectMembersModal({
    workspace_id,
    project,
    onUpdateProject,
    ...props
}) {
    const wrapperRef = useRef(null);

    const [formValues, setFormValues] = useState({
        members: [],
    });

    const [updateProjectLoading, setUpdateProjectLoading] = useState(false);

    const [teamMembers, setTeamMembers] = useState([]);

    const [defaultMembers, setDefaultMembers] = useState([]);

    const [closeAction, setCloseAction] = useState(false);

    const navigate = useNavigate();

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (event.target.nodeName == "DIV") {
                        setCloseAction(true);
                    }
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    useEffect(() => {
        if (closeAction) {
            updateProjectApi();
        }
    }, [closeAction]);

    useEffect(() => {
        setCloseAction(false);
        getWorkspaceApi();
    }, [props.openModal]);

    useEffect(() => {
        if (project) {

            var selected = [];
            let user = ReactSession.get("user");
            const currentUserId = user?.user_id;
            project.workspace_project_team_members.forEach(function (member) {
                const workspaceTeamMember = member?.workspace_team_member;
                if (
                    workspaceTeamMember &&
                    member.status == "active" &&
                    workspaceTeamMember.role != "admin" &&
                    (currentUserId === undefined || currentUserId === null || currentUserId != member.user_id)
                ) {
                    selected.push(workspaceTeamMember.id);
                }
            });
            setFormValues({ members: selected });
        }
    }, [project, props.openModal]);

    const getWorkspaceApi = () => {
        let token = ReactSession.get("token");

        getWorkspaceService(token, workspace_id)
            .then((response) => {
                if (!response) {
                    return;
                }

                if (response.success) {
                    let user = ReactSession.get("user");
                    const currentUserId = user?.user_id;

                    const transformedMembers =
                        response.workspace.workspace_team_members.map((member) => {
                            if (member.email || member.user) {
                                const { id, user, status, role, color, email, user_id } =
                                    member;

                                let memberInfo = { status };

                                if (user) {
                                    if (user.email) {
                                        memberInfo.email = user.email;
                                    }

                                    if (user.first_name || user.last_name) {
                                        memberInfo.name = `${user.first_name || ""} ${user.last_name || ""
                                            }`.trim();
                                    }
                                    memberInfo.role = role;
                                    memberInfo.color = color;
                                } else {
                                    memberInfo.name = email;

                                    memberInfo.email = email;
                                    memberInfo.role = role;
                                    memberInfo.color = color;
                                }
                                memberInfo.user_id = user_id;

                                memberInfo.id = id;

                                return memberInfo;
                            }
                        });

                    const filteredMembers = transformedMembers.filter(
                        (member) =>
                            member &&
                            (member.status === "active" ||
                                member.status === "invitation_accepted") &&
                            (currentUserId === undefined || currentUserId === null || member.user_id !== currentUserId) &&
                            member.role != "admin"
                    );
                    setTeamMembers(filteredMembers);

                    const defaultFilterMembers = transformedMembers.filter(
                        (member) =>
                            member &&
                            (member.role == "admin" || (currentUserId !== undefined && currentUserId !== null && member.user_id === currentUserId))
                    );

                    setDefaultMembers(defaultFilterMembers);
                } else {
                    if (response.message == "Workspace not found.") {
                        navigate("/404/");
                    } else {
                        showToast(response.message, "error");
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching workspace:", error);
            });
    };

    const updateProjectApi = () => {
        if (!updateProjectLoading) {
            let formData = {};

            formData.project_id = project.id;

            formData.members = formValues.members;

            let token = ReactSession.get("token");

            setUpdateProjectLoading(true);

            updateProjectService(formData, token).then((response) => {
                if (response.success) {
                    onUpdateProject(response.project);

                    if (closeAction) {
                        if (props.closeModal) {
                            props.closeModal();
                        }
                    }
                } else {
                    setCloseAction(false);
                    showToast(response.message, "error");
                }
                setUpdateProjectLoading(false);
            });
        }
    };

    return (
        <>
            <Modal
                show={props.openModal}
                centered
                size="lg"
                className="fade create-new-project-modal project-member-modal-wrap"
            >
                <Modal.Body ref={wrapperRef}>
                    <div className="create-new-project-modal-data">
                        <div className="modal-header-top">
                            <Text type={"h3"}>Project members</Text>
                            <button
                                type="button"
                                className="close"
                                onClick={() => {
                                    setCloseAction(true);
                                }}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">
                                    <Icon value="Close" size="medium" hover={true} />
                                </span>
                            </button>
                        </div>

                        <div className="create-new-project-modal-inner-data">
                            <MembersDropdownList
                                value={formValues.members}
                                onChange={(selected) => {
                                    setFormValues({
                                        ...formValues,
                                        members: selected,
                                    });
                                }}
                                defaultMembers={defaultMembers.map((user, index) => {
                                    let backgroundColor = user.color;

                                    let currentUser = ReactSession.get("user");
                                    const displayName = user?.name || user?.email || "";
                                    const avatarLabel = displayName
                                        ? displayName.charAt(0).toUpperCase()
                                        : "?";

                                    return {
                                        label: (
                                            <>
                                                <CircularNameIcon
                                                    style={{
                                                        backgroundColor,
                                                    }}
                                                    key={index}
                                                    label={avatarLabel}
                                                />
                                                {displayName}
                                                {currentUser && user.user_id == currentUser.user_id && (
                                                    <>{" (You)"}</>
                                                )}
                                                {user && user.role == "admin" && <>{" (Admin)"}</>}
                                            </>
                                        ),
                                    };
                                })}
                                options={teamMembers.map((user, index) => {
                                    let backgroundColor = user.color;
                                    const displayName = user?.name || user?.email || "";
                                    const avatarLabel = displayName
                                        ? displayName.charAt(0).toUpperCase()
                                        : "?";

                                    return {
                                        label: (
                                            <>
                                                <CircularNameIcon
                                                    style={{
                                                        backgroundColor,
                                                    }}
                                                    key={index}
                                                    label={avatarLabel}
                                                />
                                                {displayName}
                                            </>
                                        ),
                                        value: user.id,
                                    };
                                })}
                                icon={
                                    <Icon
                                        value={"user"}
                                        size={"medium"}
                                        colorClass={"gray-600-svg"}
                                    />
                                }
                                label={" Select team member"}
                                no_results_message={
                                    "No members found. Please invite them to the workspace first."
                                }
                            />
                        </div>

                        <div className="confirm-buttons-wrap modal-button-wrap">
                            <Button
                                cssclass={"w-100"}
                                type="primary"
                                size={`large`}
                                label={"Done"}
                                onClick={() => {
                                    updateProjectApi();
                                }}
                                state={"active"}
                                microLoading={updateProjectLoading}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
